var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-highcharts',{ref:"child",staticClass:"chart",attrs:{"options":_vm.chart_options_activity}})}
var staticRenderFns = []

export { render, staticRenderFns }